import {
  AuthSession,
  fetchAuthSession,
  fetchUserAttributes,
  FetchUserAttributesOutput,
  getCurrentUser,
} from 'aws-amplify/auth';
import { CognitoUserGroups } from '@/utils/helpers/cognitoUserGroups';
import getTemporaryUserMail from '@/utils/helpers/getTemporaryUserMail';

export type CognitoMetaData = {
  authSession: AuthSession;
  cognitoUserId: string;
  email: string;
  userGroups: CognitoUserGroups[];
} & (
  | {
      isTemporary: true;
    }
  | {
      isTemporary: false;
      userAttributes: FetchUserAttributesOutput;
    }
);

export async function getCognitoData(): Promise<CognitoMetaData> {
  try {
    console.log('DEBUG >> getCognitoData | start');
    const currentUser = await getCurrentUser();
    console.log('DEBUG >> getCognitoData | currentUser', currentUser);
    const details = await fetchUserAttributes();
    console.log('DEBUG >> getCognitoData | details', details);
    const authSession = await fetchAuthSession();
    console.log('DEBUG >> getCognitoData | authSession', authSession);

    console.log('Auth | user found in cognito');
    //logged user
    const userID = currentUser.userId;
    return {
      authSession: authSession,
      cognitoUserId: userID,
      email: details.email!,
      userGroups:
        (authSession.tokens?.accessToken.payload['cognito:groups'] as CognitoUserGroups[]) || [],
      isTemporary: false,
      userAttributes: details,
    };
  } catch (error) {
    //unauth user
    console.log('Auth | unauthenticated user');
    const authSession = await fetchAuthSession();
    const userID = authSession.identityId;
    console.log('DEBUG >> getCognitoData | authSession in catch error (unauth user)', authSession);

    if (!userID) {
      throw new Error('Auth | Unable to get user id');
    }
    return {
      authSession: authSession,
      cognitoUserId: userID,
      email: getTemporaryUserMail(),
      userGroups: [CognitoUserGroups.USER],
      isTemporary: true,
    };
  }
}
